import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getHostNavigationState,
  getOverlayCloseDelta,
} from "./routedOverlayUtils";

/**
 * Shared close behavior for routed overlays: when the overlay and anything stacked above
 * it were opened in-app during this page load, step back to the entry it was opened from
 * (so Back after close does not reopen it). Otherwise replace the current entry with
 * `closeTo` (deep link, bookmark, or refresh), keeping the page's own navigation state.
 */
export const useOverlayClose = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (closeTo: string) => {
      const delta = getOverlayCloseDelta(location, closeTo);
      if (delta !== undefined) {
        navigate(-delta);
        return;
      }
      navigate(
        { pathname: closeTo, search: location.search },
        { replace: true, state: getHostNavigationState(location) },
      );
    },
    [location, navigate],
  );
};
